import { render, staticRenderFns } from "./SpectateGame.vue?vue&type=template&id=21f229d4&scoped=true"
import script from "./SpectateGame.vue?vue&type=script&lang=js"
export * from "./SpectateGame.vue?vue&type=script&lang=js"
import style0 from "./SpectateGame.vue?vue&type=style&index=0&id=21f229d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f229d4",
  null
  
)

export default component.exports